module.exports = __webpack_public_path__ + "static/media/human7.fc6ab3c9.jpg";